import Site from './classes/Site.js';
new Site();